import { Button } from "reactstrap";

import styles from "Pages/Setup/Connect/Onboarding.module.css";

interface Props {
    goTo: (view: string) => void;
}

export default function SpectrumMapData({ goTo }: Props) {
    return (
        <div className={styles.panel}>
            <div className={styles.phead}>
                <div className={`${styles.logo} ${styles.logoMap}`}>⇄</div>
                <div>
                    <div className={styles.pheadName}>Ramp ↔ Spectrum mapping</div>
                    <div className={styles.pheadSub}>
                        Spectrum mapping steps are not defined yet
                    </div>
                </div>
            </div>

            <div className={styles.sec}>
                <h4>Mapping placeholder</h4>
                <p className={styles.hint}>
                    This is a placeholder for Spectrum-specific mapping and
                    behavior configuration.
                </p>
                <p className={styles.hint} style={{ marginBottom: 0 }}>
                    The Connect shell has been atomized so Spectrum mapping can
                    be introduced here without impacting CMiC or MRI mapping
                    components.
                </p>
            </div>

            <div className={styles.footbar}>
                <Button color="link" onClick={() => goTo("secondary")}>← Back to Spectrum setup</Button>
                <span className={styles.saveState}>No Spectrum mapping fields yet.</span>
            </div>
        </div>
    );
}